<template>
      <body>
        <!-- <button class="" data-toggle="modal" data-target="#delivery">
            OPEN DELIVERY process 1
        </button> -->
        <div id="delivery" class="modal" :class="{ 'show': showModal }" role="dialog" aria-labelledby="delivery">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">DELIVERY CUSTOMER</h5>
          </div>
                    <div class="modal-body1 d-flex flex-column justify-content-between">
                            <div class="">
                                
                                <div class="searchbyphone d-flex flex-row">
                                    
                                    <div class="infobox fieldOuter" >
                                        <input type="text" autocomplete="off"   placeholder="Search by phone!!" list="list-customers"  id="search" >
                                        <label for="search">Search by phone!!</label>
                                        <!-- <input type="text" name="language" > -->
                                        <div class="resaults">
                                            <div list="list-customers" id="list-customers">

                                                <!-- <div class="resaultrow mb-2">
                                                    <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                </div> -->
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe1 | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe2 | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe3 | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe4 | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe5 | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <span class="resaultrow mb-2">0585991052 | John Doe | Area</span>
                                                <div class="addnew p-2">
                                                    <div class="endresaults">- End of results -</div>
                                                    <div class="endresaultsbutton">Add New Customer</div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <table >
                                            <tr>
                                                <td>
                                                    
                                                </td>
                                            </tr>
                                        </table> -->
                                        <!-- <input type="text" autocomplete="off" placeholder="Search by phone!!"  id="search" >
                                        <label for="search">Search by phone!!</label> -->
                                    </div>
                                    <span class="icon1">
                                        <svg version="1.1" width="47" height="47" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                        <image style="overflow:visible;" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
                                        bWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp
                                        bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6
                                        eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1
                                        MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo
                                        dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw
                                        dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAv
                                        IiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RS
                                        ZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpD
                                        cmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJ
                                        RD0ieG1wLmlpZDo0MjZBOTJGRjA4Q0QxMUVEQkM4M0FFNjRBQjhCM0Q0QiIgeG1wTU06RG9jdW1l
                                        bnRJRD0ieG1wLmRpZDo0MjZBOTMwMDA4Q0QxMUVEQkM4M0FFNjRBQjhCM0Q0QiI+IDx4bXBNTTpE
                                        ZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQyNkE5MkZEMDhDRDExRURCQzgz
                                        QUU2NEFCOEIzRDRCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQyNkE5MkZFMDhDRDExRURC
                                        QzgzQUU2NEFCOEIzRDRCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBt
                                        ZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+REw/PgAAEttJREFUeNrs3dty68YOBUAhpf//5cmTK6d8
                                        bOtGDnHpfktlWyIhElgzkq1Ya9340aeFCSVU22J1VVsY5K4EhzfQ3x4r1PWUxwvXrNoCAkCGBvro
                                        eUJtDaxi16wwAAKAJioIqO3Auk4NsCAAaKIaqtqqrSAAAoAGqqGqrdoKAlDcP4a/Y1Rbxz2wtiAA
                                        GP6OVW1THqvaAgLAsMZUofmvwrV1jI4baBwAqg6oCg11uTbUVggAAYBZDVWDV1vXCAgAGtCw81FX
                                        tRUCQADQeHC9uGbdiyAAaDjdz01tUVsQADSaYeeotmrrHEEAYFgz1bzVFhAANFIMZNQWBACNpfs5
                                        q63aAo3dleBpj770RFNX24zDP0tt180XB4EAUKiRxpv/dm0491Bbg6pYbQEBoFUD/evnNVS13Rms
                                        jqjtOvn87QJAElU/A3Bmk4qkj7WrBmpbM1zEgY9jSIMAYHWafFCpLVGstnbFQAAYMaAMKrU9c/BF
                                        4dcNEABGNNKznmOprUGltoAdgPwNLtS2zHMttR1bWxAAEAKcZ8qBp7aAAKCRHjZcltcTtQUBYMpK
                                        SjN1fmoLCAAaKV7XloHTPQMIAGAAAwgAmrnz4hp2V0AAMKQAQAAAAQ9AAIDibHUDAgAAIADABN6O
                                        AASARGzLen0BBAAMKecFIAAAwtXZvDUCAgAggAACwL5Vw5XNrHsj7VJbq1RAAKB9KDLshCurfxAA
                                        NFONVG0ThjQAAcBAZvDruIo/n0AEAsC45jEtbFQ+31BbARkEAIMq63NE8serXNub2hr+IAAIARpp
                                        zvNfantqbasEIWBQADiriRw9UAyo8wbKKnh9qS0gAAxoqGc30Sj2uEcGoqoDKnttBVYY5F742OO2
                                        b9s+3vw5/q5RxrqG2qotCAD81SDPDiBXNtJd55atrh2C6+TaAi+o/hbAlSuK1fycY1hdJ6xQ1RZo
                                        EwBAcHW+wNAAMKm5hNo6VwABQPOm7vUTagsIABpN5vNTV7V1fiAAMLSRauRq67xAANB0hp6T2qot
                                        IABo6kPPRW3VVqABAUADGnoOaqu2hj8IABrR0GNXW7X96bgNfxAANKUBAyBcC2pr1Q8CgAY1N6yE
                                        118QBAQAjWpmE1XbeQHLlj8UN+3bAL8a1kp2PGqrtmoLCAADGmqordqqLSAAzGmoobZqW6y2hj4I
                                        ACMa6hlNNdT2lNoaTGoLCABbBvb64Gf5vT7qqraAAFAyGKCuaguU49sAAUAAAAAEAABAAAAABAAA
                                        QAAAAAQAAEAAAAAEAABAAAAABAAAQAAAAAQAAEAAAAAEAADgobsSvGx9+2/fua621eqqtoAA8ELD
                                        fOffarJqq7aAANCoeb7zmKG2aqu2gADQt3lqqmrbsbaCAAgAmqimmrauX88frlnXLCAAZBtQXZuq
                                        uqotUMikXwNcyRpp1gbf6fiX2qotMDsALMeotgKr2gKzAsAqdqzLsboO3GOAADBnQFVqqMs1obZC
                                        AAgAmtGsc1Bbte0YukEA0Nydi9o6HkAA0NSdk9qqrWsFBACGNlQNXW2dFwgAGg4GlWvW+YEAoNF0
                                        P0e1RW1BANBghp2r2qotIAAAhr/zBQFAY+l+zmoL0NhdCZ7y7DefGSBqm+k8ItHxdP6aZqjZfNcq
                                        21d3HHg0PDa17V3baPq6A3YAUq1KH/181W+hU1u1BZqr+hmAMxtUJH2sK1ZralunrlVqCwgA7QfU
                                        Wc25al2jyOvlmj33ce0ugAAwppFOH1bqet7gU1tgVACo2Eir1KLq6iyKXGcVr1khAAQAK1TNVG3d
                                        I6ODJggAGFTO89KBp7aAAKCRHjZcltcTtQUBYMJK6sqG1r2Zqq3zAwQAKMt71cIHCACAAQwIAGjm
                                        hhSfsLsCAoAhhdcXQAAAAAQAKM5WNyAAwEDejgAEAABAALiSbVmvL4AAgCHlvNjMWyMgAADCFSAA
                                        aKbkeV2tUt0zIAAk0aUhd2+kBoXaAgKAZlokFPlqZNQWBAA0UueZMKSpLSAAFG2mS23V1uvosxUg
                                        AORpHlWHRxSobdXhHwPPWbACAcAqRyNVV8HV8AcBwLD69DGXup5WW9dsrce1/Q8CQNomspI+VodG
                                        qrY1ApZgBQKAFevAVX+obena3obWFni1Ia1V+n7fdfBR9HjUtt+QPvpcsh0PsMldCdI1bbVtHrpv
                                        Mz/Bb/hDMtXfApjYVEJtnTPA9AAAgobzBYYGgEnNJdRWbQEEgFnNNNTWOaotIABoNNS/bkJtAQFA
                                        w8l8Xuqqts4LBACGNlINXW1dKyAAaD5Dz0Vt1RYQADT3oeegtmr71/ELMiAAaEaNB0G4JtS2YTAE
                                        AcBugAHVMGA5VscLDAsAVRqUlZ/aVgxYhj8UNenLgL4a1Up6XNVruxK/5mqrtsDgAJAxCIS6qqva
                                        AgLAnJVVNK/rTW3b1dbgBwGgZUPd0VRDbdVWbQEBYEZT1TzVVm0BAaBoU/1uaZZqq7aAAKDJorZq
                                        C5Tjy4AAQAAAAAQAAEAAAAAEAABAAAAABAAAQAAAAAQAAEAAAAAEAABAAAAABAAAQAAAAAQAAOCh
                                        uxI8bT3xb3znurpmr6WaAgLAAU30mZ/VaD+vrboee53+9POuUxAANNMTHzvU9rTHDfU85HEFARAA
                                        NFNNVm0H1nJ6YAUBwHAyrNRWLQUBEAAMJw1WbefWcwkB0M+kXwNcju20Y1fb/vVcxa9TYGgAWEWO
                                        camr118tAQHAUHWcM64FtQQEACuVEseutmppNwAEAI1p2DmorVoKASAAaEhWq2qrlkIACAAakdWq
                                        2qolIABoQFaraquWgACA1arX0DkCAoCmw6jrxzUKCAAaa5lzVVt1dL4gAAAIASAAzG4ycbvuy1GW
                                        2pY656sHoS/xAX50V4KPmmhc1PDP/na2dXFdf/p/FVeUK+l1ujNECiAgAJRrrvHhz9kCPba2sem1
                                        rzi0ImkthQBIzGcAjh3+3x+j4ip9nVzXSPL6dFj9H1FPwxkEAKv/k4a2BntOHc4MWGtYPaPo/QrY
                                        AUjfBENtR9W2wi7KzkAFCAAjB9SZz7GSP17l2rpOAQFg0OpKc3W+n15nq0Etw30LAoAhhdfRuQEC
                                        gMaqmavt5lVuNHr97AKAAEDCpqo5MzWsggAwaNhd3dy6N9YutV0XXZsGMCAAgNV3q+Ow0wQCAAAg
                                        AFjhOS+y1tBrCgKABovX9we2tdULBACgZTgVmkEAAAAEAABAAIAEVtHnyr7N7m0AEAAMCAAQABBC
                                        hCsAAQBAUAQBQAOi6uu68z1v768DAsCAJtk9fAhXAAKAQVUkFIXXE0AAwJBynnQNikDRAFD560mn
                                        DcXKtTXoAAHAoEr7HJH88SrXFkAAEAIMKLUFEAAMKgNKbQEEgEuc+f7sSvpYu2qgtt7/Bwa4K8Gf
                                        wyU+/HnUFkAAOGGVdvYwWC+sCtfmc1dbq38AOwAbV66oLUB51T8EOHG1FmrrnAGmBwBNG9cRwNAA
                                        YEgZigAMDQATBlWorXMEEABmNfFQW+cGIABo5rheAASA5k09HIfzARAArFAdDwACwB+DKhqcg+Ny
                                        bQAIAEOGVYUBFYVrC8BtxlsA4Vgdr+EPMC8AVGn+obZqC7DLpC8D+hoCK+lxqa3aAggAA4ZVqK3a
                                        AggAc4ZVqK3aAggAeYbV2QNr8tfrqiuAADAmDBhMv9dCbQEEgDJDC7UFaMOfAgYAAQAAEAAAAAEA
                                        ABAAAAABAAAQAAAAAQAAEAAAAAEAABAAAAABAAAQAAAAAQAAEAAAAAEAAPh/dyUAClpv/lwoHQgA
                                        wIyh/9tjCAMIAACNh74wAAIAYPD/+XyCAAIAwIDBLwggAAAMHvyCAOP4NUDA8K95bCAAAGUH/ypy
                                        nCAAAAgrIAAATAsCIAAACAEgAAAIASAAAAgBIAAACAEgAAAAAgCAXQAQAACEABAAAIBD+TIgoIu4
                                        eFW+br48CAEAYPvAzxAIhADK8BYAUHHwx8afeycEgAAAcPHgf7QzAAIAQOLhnzFMgAAAUGT473hs
                                        bwMgAAAkHf47nwMEAIAhg9kuAAIAQPLhbxcAAQBg6Mr/jOe1C4AAAFBgJW4nAAEAABAAAKasvo8+
                                        Dm8DIAAAJB/+IAAACCQgAAAYtiAAAAgmL/A5ANK5KwFAep8GCLssCABA21W2of/cY6k5AgBA46H/
                                        6DkEAQEAgF/E5qF8VdgQBgbyIUDgyuFqxZ/jA4I+pGgHAIChA9dbA3YAABi82rYbYAcAgKGD1W6A
                                        HQAAhBYEAACEAAQAAIQABAAAhAAEAACEAAQAAIQABAAAQAAAwC4AAgAAQgACAABwKH8KGKCeR3+i
                                        d9fqfN38uWABAIBLh/5P/3ZHEBACBAAALh78VwYBivEZAICew/+Mx/lrFwA7AAAkHNh2A7ADADBs
                                        +O94fMHCDgADvHuj+6AQ5LhHwsBGAGBnql+CAbQOyH4jQADA0H/7+TQPDH+7AAgANB76wgDkCB7r
                                        hHvYvVuADwGyEq8CMh8bVF79Z3p+BAAGr/oFAQx/EAAwUMsHFqg2/AURAQCrfuEFENYFAKz6nQ9M
                                        WXHbBRAAkMadG0B3fg3Q8O9yjlYvWP3P7WdqKgAweHUsBMAx4WQluCfXAf9ePxAADH8hABjYr/xR
                                        MQHAzSQEAMN7lTDwAx8CRFOBfQyf/+7RNfC5BQAMP3WAkSEl0/Ad3yMEAIQAYOr9OHo3QABwg6kJ
                                        MH3IjuwTPgTIUSLxTeWDgWCwPnusY3qFAOBGO2LQVwgFQgCgV/wPbwHwyjCPAx8nLrqxAfQKAYCN
                                        g3/3YwsBgF4hALhQkw/nq3YEAMaGAAGA3wbyVc8bbmpACBAAEEDc1IAQIADQePUvBAAIAFw0xLK9
                                        D+9zAYBdAAGAocJNDQgBAgBCgJsa4AD+EiCVQoBBDRYBVwf5Nn8p0A4AdgLsAkDW+/2VXw3e+fdE
                                        WvQLAQAhQAiATve5PywmAKA5AEVX/RX6RPkFgwAAdgGga7C3GyAAuGmctxAAg/vYWY9fulcIAFS+
                                        mCV7MPz1CwEAzUOyB/evhZMAAIDhbxdAAKB1mrULAO5ZIUAAQEMRAsDwt3ASANxQhh6AXQABADe1
                                        QAQGrxAgANBv6AkBAAKAZA2gR1k0CQDYBbALAFg4CQAIAYD7UQDATYZdANA3BQCwCwDQt1cKANKs
                                        etgFAD3JDgAYegACABJ3jxBgFwBAAACALYsmAQC7AHYBAAQAACxEEACwC6AZAQgACAEACABgFwBA
                                        AMAugBAAIABg6AEgAHAFuwAAAgCGHgACAFNCgN8IABAAYHQYAhAAsAsAgAAAdgEABADsAuD6AwQA
                                        NGF1ABAAKMsugMAECABo5uqAWoMAgF0ADHFAAEAzV4dR9Qo1hjzuSgAcFAKWYAUCADUb+ZFb96to
                                        4z+6DnYEgJS8BQCwJ9gISAgAjFnBWUkDCAAwNggBCAAYfjDwvnBfIQAwjrcBAAQAGLPiwzXhWkIA
                                        wPCDRvdGnPBvYTt/B4Ad/E0AOofkJTwjANCtwRl+8FoYgDK8BQAAAgCcpupugtUdIAAwjuEHIAAA
                                        AAIAdgFe520AAAEAABAAAAABgFS8DeBtAEAAAAAEAABAAKAtW+BqgGsdAQA+4jsGQIhAAADAAEcA
                                        QENQA3CfIADQlrcBoMYgjzd+hgLuSgDAk0N9GfwCAABzgwANeAsADQBAAICt/FlgAAEAABAAAAAB
                                        gFRsgQMIAPARnwMAEAAAAAEAK2AABAAAQACgD98LACAAAAACAJn5HACAAAAACADwmoqfA7ADAggA
                                        AIAAwBxWwQACAAAgAAAAAgA84A8CAQgAAIAAQGbh3NUPEAAAwx8QAMAQBxAA4G9VPwgYLwaBV/89
                                        gACAVXDhOhj8QAp3JQBhCLADAAAIAACAAAB7+IuAAAIAhXjvG0AAAAAEAABAAAAABAD4zgcBAQQA
                                        CvFBQAABAAAQAAAAAQAAEAAAAAEA/CYAgABAJX4TACC5uxIARe3cIRJqEQAABgz8R88tEFCetwAA
                                        w/+94/EZFQQAgEHDv8qxgQCA5o/X3zUKAgB7eI8UgxUEAABAAADoxW4FAgAAIAAAAAIAvMX2KoAA
                                        QCF+EwBAAAAQdkEAAAAEAACrahAAAAQVEADAbwIYro4PBAA0cKZdQ+HahmPdlQAoGCZXgmMAAQDA
                                        IIZavAUAAAIAACAAQC5+EwBAAKAQ79cCCAAAgAAAAAgAAIAAAN/5ICCAAAAACAAAgAAAAAgAAIAA
                                        wGb+GBCAAAAACAAAwFZ3JQCSqf63HrzdhQAAMGTo/3YuwgBpeQsAKyOuHpar+fmBAAAwNOSAAAAf
                                        sotgMIL+JADgBsHwd77oTQIA3W804QHIGgLK9ScBAOkcYCABgCsHerzwb6E6bwP0603v/Ps0/B0A
                                        Mq3s/f40kL03telPAgBZbzhwfeO1O5G3AABgIAEAAAQAgC1sh4MAACDwgAAAGIqAAAAIAc4RjufX
                                        AIEsA3I1PS9I6V8BBgDSmpgPE5GiqwAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 -0.0233 -0.2326)">
                                        </image>
                                        </svg>
                                    </span>
                                </div>
                                
                            </div>
                            <div class="buttons d-flex flex-row justify-content-end">
                                <div class="cancle " data-dismiss="modal"> 
                                    <span>cancel</span>
                                </div>
                                <div class="submit"> 
                                    <span>submit</span>
                                </div>
                                
                            </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
                           
        <div class="modal-backdrop" v-if="showModal"></div>
 
    </body>
</template>
<script>
export default {
  data() {
    return {
      showModal: true, 
      inputValue: '',
      items: [
        '0585991052 | John Doe | Area',
        '0585991052 | John Doe1 | Area',
        '0585991052 | John Doe2 | Area',
      ]
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item =>
        item.toLowerCase().includes(this.inputValue.toLowerCase())
      );
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    handleDblClick(event) {
      event.preventDefault();
      this.showList = !this.showList;
    },
    handleBlur(event) {
      event.preventDefault();
      setTimeout(() => {
        this.showList = false;
      }, 100);
    },
    handleClick(event) {
      event.preventDefault();
      this.inputValue = event.target.textContent;
      this.showList = false;
    },
    handleKeyup(event) {
      event.preventDefault();
      if (event.which === 27) { // esc
        this.showList = false;
      } else if (event.which === 13) { // enter
        if (this.filteredItems.length === 1) {
          this.inputValue = this.filteredItems[0];
          this.showList = false;
        }
      } else if (event.which === 9) { // tab
        this.showList = false;
      } else {
        this.showList = true;
      }
    },
  },
  mounted() {
  }
};
</script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  

  
  